import React from 'react';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../paths';

const LoginSuccess = () => {
  const navigate = useNavigate();

  return (
    // Added 'min-h-screen' and 'flex items-center justify-center' to center vertically and horizontally
    <div className="w-full min-h-screen flex flex-col items-center justify-center text-center p-6 bg-transparent">
      {/* Success Icon */}
      <div className="mb-6 bg-green-500/10 p-4 rounded-full">
        <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>

     <h1 className="text-4xl sm:text-5xl font-bold font-barlow text-black mb-2 leading-tight py-2">
  Login Successful!
</h1>
      
      <p className="text-sm font-semibold font-montserrat text-black tracking-wider uppercase mb-6">
        Welcome back to Spirit
      </p>

      <div className="max-w-md mb-8">
        <p className="text-xs sm:text-sm text-gray-600 font-montserrat leading-relaxed">
          The CA Program is now live. Your dashboard is ready for you to manage your activities, view updates, and track your impact.
        </p>
      </div>

      <button 
        onClick={() => navigate(paths.dashboard)} 
        className="w-full max-w-[200px] bg-black hover:bg-gray-900 text-white font-bold text-xs py-3 rounded-sm transition-colors tracking-widest font-montserrat"
      >
        Go to Dashboard
      </button>

      {/* Footer tagline */}
      <div className="mt-12">
        <p className="text-[9px] uppercase tracking-widest text-gray-600 font-medium">
          Together, we're redefining what student sport can be.
        </p>
      </div>
    </div>
  );
};

export default LoginSuccess;